import { useEffect, useMemo, useRef, useState } from "react";
import "./WelcomeTypingIntro.css";

const DEFAULT_TEXT = "Seja muito bem-vindo à Clínica Dionara Krause!";
const LOGO_SRC = "/assets/images/logo/Logo.png";

export default function WelcomeTypingIntro({
  text = DEFAULT_TEXT,
  typingSpeed = 70,
  finishDelay = 1000,
  onFinish,
}) {
  const typingTimerRef = useRef(null);
  const finishTimerRef = useRef(null);
  const leaveTimerRef = useRef(null);

  const [typedText, setTypedText] = useState("");
  const [isLeaving, setIsLeaving] = useState(false);

  const letters = useMemo(() => Array.from(text), [text]);

  useEffect(() => {
    let index = 0;
    let hasFinished = false;

    const clearTimers = () => {
      window.clearTimeout(typingTimerRef.current);
      window.clearTimeout(finishTimerRef.current);
      window.clearTimeout(leaveTimerRef.current);

      typingTimerRef.current = null;
      finishTimerRef.current = null;
      leaveTimerRef.current = null;
    };

    const finishTyping = () => {
      if (hasFinished) return;

      hasFinished = true;

      finishTimerRef.current = window.setTimeout(() => {
        setIsLeaving(true);

        leaveTimerRef.current = window.setTimeout(() => {
          onFinish?.();
        }, 520);
      }, finishDelay);
    };

    const typeNextLetter = () => {
      setTypedText(letters.slice(0, index + 1).join(""));
      index += 1;

      if (index < letters.length) {
        typingTimerRef.current = window.setTimeout(typeNextLetter, typingSpeed);
        return;
      }

      finishTyping();
    };

    typingTimerRef.current = window.setTimeout(() => {
      typeNextLetter();
    }, 250);

    return () => {
      clearTimers();
    };
  }, [letters, typingSpeed, finishDelay, onFinish]);

  return (
    <div className={`welcome-typing-intro ${isLeaving ? "is-leaving" : ""}`}>
      <div className="welcome-typing-intro__overlay" />

      <div className="welcome-typing-intro__content">
        <span
          className="welcome-typing-intro__brand"
          aria-label="Clínica Dionara Krause"
        >
          <img src={LOGO_SRC} alt="Clínica Dionara Krause" />
        </span>

        <p className="welcome-typing-intro__eyebrow">
          Clínica Dionara Krause
        </p>

        <h1>
          {typedText}
          <span className="welcome-typing-intro__cursor" />
        </h1>
      </div>
    </div>
  );
}